export const api = {
                                                 //-----------
                                                 //DEVELOPMENT
                                                 //-----------
  //---
  //DEV---testapi.e-paylink.com/testapi6.e-paylink.com
  //---
//   webappENV                                      : "DEV",
//   url                                            : "https://testapi.e-paylink.com", //api
//   url_onlinemt                                   : "https://testapi6.e-paylink.com",
//   url_website                                    : "https://www.westernunion.gr",
//   webapp_path                                    : "/onlinemt",
//   allowOrigin_key                                : "Access-Control-Allow-Origin",
// //allowOrigin_val                                : "http://localhost:3000",
// //allowOrigin_val                                : "http://192.168.1.213:3000",
//   allowOrigin_val                                : "https://testapi6.e-paylink.com",
//   tagManagerKey_old                              : "GTM-5S8Q67L",//PROD-worldbridge old
//   tagManagerKey                                  : "GTM-WTKB4XM",//PROD-worldbridge new
// //tagManagerKey                                  : "GTM-NMDRRJ8",//DEV-veriah
//   buildDateStr                                   : "",//xxxx
//   buildDateAPI                                   : "2026-08-26 11:00", //"2025-07-15 17:00",
//   buildNumber                                    : 447,
//   buildDateEnabled                               : false,
//   appVersion                                     : "3.0.3",
//   apiVersion                                     : "3.0.3",
//   CookieBotdomainGroupId                         : "7869e0a7-9dcc-4910-90bd-26d003f27603", //it_dept@worldbridge.gr
// //CookieBotdomainGroupId                         : "b61334ac-b9f5-46c0-bdca-b574163d1661", //nikos.menis@veriah.com
//   cache_Countries_enabled                        : true,
//   cache_Countries_TTL_min                        : 60,
//   cache_Currencies_enabled                       : true,
//   cache_Currencies_TTL_min                       : 60,
//   cache_Locations_enabled                        : true,
//   cache_Locations_TTL_min                        : 60,
//   cache_CategoriesCompanies_enabled              : true,
//   cache_CategoriesCompanies_TTL_min              : 60,
//   cache_ServiceAvailability_enabled              : false,
//   cache_ServiceAvailability_TTL_min              : 1,
//   cache_CheckAppVersion_enabled                  : true,
//   cache_CheckAppVersion_TTL_min                  : 1,
//   BP_FUNCTIONALLITY_ENABLED                      : true,
//   print_navigation                               : true,
//   print_logs                                     : true,
  //---
  //DEV---testmob.e-paylink.com/testweb.e-paylink.com
  //---
//   webappENV                                      : "DEV",
//   url                                            : "https://testmob.e-paylink.com", //api
//   url_onlinemt                                   : "https://testweb.e-paylink.com",
//   url_website                                    : "https://www.westernunion.gr",
//   webapp_path                                    : "/onlinemt",
//   allowOrigin_key                                : "Access-Control-Allow-Origin",
// //allowOrigin_val                                : "http://localhost:3000",
// //allowOrigin_val                                : "http://192.168.1.213:3000",
//   allowOrigin_val                                : "https://testweb.e-paylink.com",
//   tagManagerKey_old                              : "GTM-5S8Q67L",//PROD-worldbridge old
//   tagManagerKey                                  : "GTM-WTKB4XM",//PROD-worldbridge new
// //tagManagerKey                                  : "GTM-NMDRRJ8",//DEV-veriah
//   buildDateStr                                   : "",
//   buildDateAPI                                   : "2024-06-27 09:00",
//   buildNumber                                    : 423,
//   buildDateEnabled                               : false,
//   appVersion                                     : "3.0.3",
//   apiVersion                                     : "3.0.3",
//   CookieBotdomainGroupId                         : "4fb35ba9-a409-4085-b288-72c55f98487d", //it_dept@worldbridge.gr
// //CookieBotdomainGroupId                         : "b61334ac-b9f5-46c0-bdca-b574163d1661", //nikos.menis@veriah.com
//   cache_Countries_enabled                        : true,
//   cache_Countries_TTL_min                        : 60,
//   cache_Currencies_enabled                       : true,
//   cache_Currencies_TTL_min                       : 60,
//   cache_Locations_enabled                        : true,
//   cache_Locations_TTL_min                        : 60,
//   cache_CategoriesCompanies_enabled              : true,
//   cache_CategoriesCompanies_TTL_min              : 60,
//   cache_ServiceAvailability_enabled              : false,
//   cache_ServiceAvailability_TTL_min              : 1,
//   cache_CheckAppVersion_enabled                  : true,
//   cache_CheckAppVersion_TTL_min                  : 1,
//   BP_FUNCTIONALLITY_ENABLED                      : true,
//   print_navigation                               : true,
//   print_logs                                     : true,
  //-------
  //PREPROD---vulnapi.e-paylink.com/testonlineapp.e-paylink.com
  //-------
//   webappENV                                      : "DEV",
//   url                                            : "https://vulnapi.e-paylink.com", //api
//   url_onlinemt                                   : "https://testonlineapp.e-paylink.com",
//   url_website                                    : "https://www.westernunion.gr",
//   webapp_path                                    : "/onlinemt",
//   allowOrigin_key                                : "Access-Control-Allow-Origin",
// //allowOrigin_val                                : "http://localhost:3000",
// //allowOrigin_val                                : "http://192.168.1.213:3000",
//   allowOrigin_val                                : "https://testonlineapp.e-paylink.com",
//   tagManagerKey_old                              : "GTM-5S8Q67L",//PROD-worldbridge old
//   tagManagerKey                                  : "GTM-WTKB4XM",//PROD-worldbridge new
// //tagManagerKey                                  : "GTM-NMDRRJ8",//DEV-veriah
//   buildDateStr                                   : "",
//   buildDateAPI                                   : "2024-09-17 12:40",
//   buildNumber                                    : 430,
//   buildDateEnabled                               : false,
//   appVersion                                     : "3.0.3",
//   apiVersion                                     : "3.0.3",
//   CookieBotdomainGroupId                         : "4fb35ba9-a409-4085-b288-72c55f98487d", //it_dept@worldbridge.gr
// //CookieBotdomainGroupId                         : "b61334ac-b9f5-46c0-bdca-b574163d1661", //nikos.menis@veriah.com
//   cache_Countries_enabled                        : true,
//   cache_Countries_TTL_min                        : 60,
//   cache_Currencies_enabled                       : true,
//   cache_Currencies_TTL_min                       : 60,
//   cache_Locations_enabled                        : true,
//   cache_Locations_TTL_min                        : 60,
//   cache_CategoriesCompanies_enabled              : true,
//   cache_CategoriesCompanies_TTL_min              : 60,
//   cache_ServiceAvailability_enabled              : false,
//   cache_ServiceAvailability_TTL_min              : 1,
//   cache_CheckAppVersion_enabled                  : true,
//   cache_CheckAppVersion_TTL_min                  : 1,
//   BP_FUNCTIONALLITY_ENABLED                      : true,
//   print_navigation                               : true,
//   print_logs                                     : true,
    //-------
    //PENTEST---westernunionapi.e-paylink.com/paylinkapp.e-paylink.com
    //-------
//   webappENV                                      : "DEV",
//   url                                            : "https://westernunionapi.e-paylink.com", //api
//   url_onlinemt                                   : "https://paylinkapp.e-paylink.com",
//   url_website                                    : "https://www.westernunion.gr",
//   webapp_path                                    : "/onlinemt",
//   allowOrigin_key                                : "Access-Control-Allow-Origin",
// //allowOrigin_val                                : "http://localhost:3000",
// //allowOrigin_val                                : "http://192.168.1.213:3000",
//   allowOrigin_val                                : "https://paylinkapp.e-paylink.com",
//   tagManagerKey_old                              : "GTM-5S8Q67L",//PROD-worldbridge old
//   tagManagerKey                                  : "GTM-WTKB4XM",//PROD-worldbridge new
// //tagManagerKey                                  : "GTM-NMDRRJ8",//DEV-veriah
//   buildDateStr                                   : "",
//   buildDateAPI                                   : "2024-07-31 15:30",
//   buildNumber                                    : 427,
//   buildDateEnabled                               : false,
//   appVersion                                     : "3.0.3",
//   apiVersion                                     : "3.0.3",
//   CookieBotdomainGroupId                         : "4fb35ba9-a409-4085-b288-72c55f98487d", //it_dept@worldbridge.gr
// //CookieBotdomainGroupId                         : "b61334ac-b9f5-46c0-bdca-b574163d1661", //nikos.menis@veriah.com
//   cache_Countries_enabled                        : true,
//   cache_Countries_TTL_min                        : 60,
//   cache_Currencies_enabled                       : true,
//   cache_Currencies_TTL_min                       : 60,
//   cache_Locations_enabled                        : true,
//   cache_Locations_TTL_min                        : 60,
//   cache_CategoriesCompanies_enabled              : true,
//   cache_CategoriesCompanies_TTL_min              : 60,
//   cache_ServiceAvailability_enabled              : false,
//   cache_ServiceAvailability_TTL_min              : 1,
//   cache_CheckAppVersion_enabled                  : true,
//   cache_CheckAppVersion_TTL_min                  : 1,
//   BP_FUNCTIONALLITY_ENABLED                      : true,
//   print_navigation                               : true,
//   print_logs                                     : true,
                                                 //-------
                                                 //STAGING
                                                 //-------
//-------
//STAGING---api.e-paylink.com/www.westernunion.gr
//-------
//   webappENV                                      : "STAGING",
//   url                                            : "https://stagingapi.e-paylink.com", //api
//   url_onlinemt                                   : "https://www.westernunion.gr",
//   url_website                                    : "https://www.westernunion.gr",
//   webapp_path                                    : "/onlinemtstaging",
//   allowOrigin_key                                : "Access-Control-Allow-Origin",
// //allowOrigin_val                                : "http://localhost:3000",
// //allowOrigin_val                                : "http://192.168.1.213:3000",
//   allowOrigin_val                                : "https://www.westernunion.gr",
//   tagManagerKey_old                              : "GTM-5S8Q67L",//PROD-worldbridge old
//   tagManagerKey                                  : "GTM-WTKB4XM",//PROD-worldbridge new
// //tagManagerKey                                  : "GTM-NMDRRJ8",//DEV-veriah
//   buildDateStr                                   : "",
//   buildDateAPI                                   : "2023-05-22 09:00",
//   buildNumber                                    : 351,
//   buildDateEnabled                               : false,
//   appVersion                                     : "3.0.3",
//   apiVersion                                     : "3.0.3",
//   CookieBotdomainGroupId                         : "4fb35ba9-a409-4085-b288-72c55f98487d", //it_dept@worldbridge.gr
// //CookieBotdomainGroupId                         : "b61334ac-b9f5-46c0-bdca-b574163d1661", //nikos.menis@veriah.com
//   cache_Countries_enabled                        : true,
//   cache_Countries_TTL_min                        : 60,
//   cache_Currencies_enabled                       : true,
//   cache_Currencies_TTL_min                       : 60,
//   cache_Locations_enabled                        : true,
//   cache_Locations_TTL_min                        : 60,
//   cache_CategoriesCompanies_enabled              : true,
//   cache_CategoriesCompanies_TTL_min              : 60,
//   cache_ServiceAvailability_enabled              : false,
//   cache_ServiceAvailability_TTL_min              : 1,
//   cache_CheckAppVersion_enabled                  : true,
//   cache_CheckAppVersion_TTL_min                  : 1,
//   BP_FUNCTIONALLITY_ENABLED                      : true,
//   print_navigation                               : false,
//   print_logs                                     : false,
                                                 //----------
                                                 //PRODUCTION
                                                 //----------
  //---
  //PROD---api.e-paylink.com/www.westernunion.gr
  //---
  webappENV                                      : "PROD",
  url                                            : "https://api.e-paylink.com", //api
  url_onlinemt                                   : "https://www.westernunion.gr",
  url_website                                    : "https://www.westernunion.gr",
  webapp_path                                    : "/onlinemt",
  allowOrigin_key                                : "Access-Control-Allow-Origin",
//allowOrigin_val                                : "http://localhost:3000",
//allowOrigin_val                                : "http://192.168.1.213:3000",
  allowOrigin_val                                : "https://www.westernunion.gr",
  tagManagerKey_old                              : "GTM-5S8Q67L",//PROD-worldbridge old
  tagManagerKey                                  : "GTM-WTKB4XM",//PROD-worldbridge new
//tagManagerKey                                  : "GTM-NMDRRJ8",//DEV-veriah
  buildDateStr                                   : "",//xxxx
  buildDateAPI                                   : "2026-08-31 09:00",
  buildNumber                                    : 449,
  buildDateEnabled                               : false,
  appVersion                                     : "3.0.4",
  apiVersion                                     : "3.0.4",
  CookieBotdomainGroupId                         : "4fb35ba9-a409-4085-b288-72c55f98487d", //it_dept@worldbridge.gr
//CookieBotdomainGroupId                         : "b61334ac-b9f5-46c0-bdca-b574163d1661", //nikos.menis@veriah.com
  cache_Countries_enabled                        : true,
  cache_Countries_TTL_min                        : 60,
  cache_Currencies_enabled                       : true,
  cache_Currencies_TTL_min                       : 60,
  cache_Locations_enabled                        : true,
  cache_Locations_TTL_min                        : 60,
  cache_CategoriesCompanies_enabled              : true,
  cache_CategoriesCompanies_TTL_min              : 60,
  cache_ServiceAvailability_enabled              : false,
  cache_ServiceAvailability_TTL_min              : 1,
  cache_CheckAppVersion_enabled                  : true,
  cache_CheckAppVersion_TTL_min                  : 1,
  BP_FUNCTIONALLITY_ENABLED                      : true,
  print_navigation                               : false,
  print_logs                                     : false,
  //----
  //PROD---www.e-paylink.com/www.e-paylink.com
  //----
//   webappENV                                      : "PROD",
//   url                                            : "https://api.e-paylink.com",
//   url_onlinemt                                   : "https://www.e-paylink.com",
//   url_website                                    : "https://www.e-paylink.com",
//   webapp_path                                    : "/onlinemt",
//   allowOrigin_key                                : "Access-Control-Allow-Origin",
// //allowOrigin_val                                : "http://localhost:3000",
// //allowOrigin_val                                : "http://192.168.1.213:3000",
//   allowOrigin_val                                : "https://www.e-paylink.com",
//   tagManagerKey_old                              : "GTM-5S8Q67L",//PROD-worldbridge old
//   tagManagerKey                                  : "GTM-WTKB4XM",//PROD-worldbridge new
// //tagManagerKey                                  : "GTM-NMDRRJ8",//DEV-veriah
//   buildDateStr                                   : "",
//   buildDateAPI                                   : "2022-07-27 12:30",
//   buildNumber                                    : 300,
//   buildDateEnabled                               : false,
//   appVersion                                     : "3.0.3",
//   apiVersion                                     : "3.0.3",
//   CookieBotdomainGroupId                         : "4fb35ba9-a409-4085-b288-72c55f98487d", //it_dept@worldbridge.gr
// //CookieBotdomainGroupId                         : "b61334ac-b9f5-46c0-bdca-b574163d1661", //nikos.menis@veriah.com
//   cache_Countries_enabled                        : true,
//   cache_Countries_TTL_min                        : 60,
//   cache_Currencies_enabled                       : true,
//   cache_Currencies_TTL_min                       : 60,
//   cache_Locations_enabled                        : true,
//   cache_Locations_TTL_min                        : 60,
//   cache_CategoriesCompanies_enabled              : true,
//   cache_CategoriesCompanies_TTL_min              : 60,
//   cache_ServiceAvailability_enabled              : false,
//   cache_ServiceAvailability_TTL_min              : 1,
//   cache_CheckAppVersion_enabled                  : true,
//   cache_CheckAppVersion_TTL_min                  : 1,
//   BP_FUNCTIONALLITY_ENABLED                      : true,
//   print_navigation                               : false,
//   print_logs                                     : false,



  helpdeskURL                                    : "https://helpdesk.e-paylink.com/client.php?locale=en&style=original&url=https%3A//www.e-paylink.com/onlinemt/login%3Fcountry%3DEU%26applicationToRun%3DPAYBYBANK%26lang%3Den%26countryName%3DDK&referrer=https%3A//www.e-paylink.com/onlinemt/login%3Fcountry%3DGR%26applicationToRun%3DPAYBYBANK%26countryName%3DGR%26lang%3Del",
  captchKey                                      : "6LfTvNwUAAAAAMQ8Wpz25r8cVO8ltfo5ji7WeWd6",
  captchKeyV3                                    : "6LdGJa8pAAAAAMIy3pyTfiEiTDpz6MPlykiZRicu",
  capthaVersion                                  : "v3",
  username                                       : "dmVyaWFo",
  password                                       : "cGFub3M5OQ==",
  appType                                        : 4,//3->4 11/06/2021
  appId                                          : "5F9079A0753F487AB565B619887071F8",
  channel                                        : "webapp-react",
  platform                                       : "webapp-react",
  platformWeb                                    : "webapp-react",
  lang                                           : "en",
  UserAgent                                      : "PayLink/1.7.0---Apple---iPhone 6s---iOS---12.4---750x1334",
  preferred_locale                               : "el",
  gmtDiff                                        : "10800",
  deviceId                                       : "userTool123456casc",
  role                                           : "user",

  print_HTTP_URL                                 : false,
  print_HTTP_POST                                : false,
  print_HTTP_RESP_HEADERS                        : false,
  print_HTTP_COOKIES                             : false,
  print_HTTP_RESP_BODY                           : false,
  print_HTTP_RESP_BODY_SIZE                      : false,
//print_navigation                               : false,
//print_logs                                     : false,

  disableChromeAutocomplete                      : false,

  backButtonAtHeader                             : false,
  backButtonAtBottom                             : true,

  TransferOnline1_PaymentMethod_None             : "-1",
  TransferOnline1_PaymentMethod_BankTransfer     : "0",
  TransferOnline1_PaymentMethod_CreditCard       : "1",

  TransferOnline1_TransferMethod_None            : "-1",
  TransferOnline1_TransferMethod_Cash            : "0",
  TransferOnline1_TransferMethod_Bank            : "1",

  finalizeoutbound_type_BankTransfer             : "0",
  finalizeoutbound_type_CreditCard_success       : "1",
  finalizeoutbound_type_CreditCard_failure       : "2",

  TransferOnline1_type_send                      : "0",
  TransferOnline1_type_receive                   : "1",

  promo_type_selected_none                       : "0",
  promo_type_selected_promo                      : "1",
  promo_type_selected_card                       : "2",

  ScanDocuments_items_num_ONE                    : 1,
  ScanDocuments_items_num_TWO                    : 2,

  ScanDocuments_currItemIndex_1                  : 1,
  ScanDocuments_currItemIndex_2                  : 2,

  storeloc_flow_COSTCALC_WU                      : "0",
  storeloc_flow_COSTCALC_GC                      : "1",
  storeloc_flow_NORMAL_FLOW                      : "2",

  generic_flow_header_0_items                    : "0",
  generic_flow_header_3_items                    : "3",
  generic_flow_header_4_items                    : "4",

  FLOW_confirm_register_after_login_simple       : "0",
  FLOW_confirm_register_after_login_transfer     : "1",

  popup_tile                                     : "PayLink – Western Union",

  isCaptchaEnabled                               : false,
  isCaptchaEnabled_LoginPage_login               : false,
  isCaptchaEnabled_LoginPage_resend              : true,

  show_error_generic_input                       : true,

  is_pdf_upload_enabled                          : true,

  shouldUseTagManager                            : true,

  snackBarDurationMS                             : 3000,

  initialLoadGracePeriodMS                       : 750,

//regValidationType                              : "EMAIL",
  regValidationType                              : "SMS",

  //Use Password Header functionallity
  use_uph                                        : false,

  autoCompleteSearchEnabled                      : true,

  shouldUseCriteo                                : true,
  criteo_account                                 : 83203,

  shouldUseSMSVerify202104                       : true,
  OTPRetryPeriodMS                               : 30000,

  //idle time
  uilatstats_inactivity_mins                     : 20,
//uilatstats_inactivity_mins                     : 30,

  //campaign 2022-07-01---2022-09-10
  campaign_enabled                               : false,
  campaign_startDate                             : "2022-07-01",
  campaign_endDate                               : "2022-09-10",
  campaign_prefix                                : "2022_30_percent_off",
  campaign_cap_per_session                       : 3,

  new_registration_enabled                       : true,

  //2022-11-17(dev)
//hasD2BfName                                    : "isD2B",
  hasD2BfName                                    : "isDigitalD2B",

  columns_bills_md                               : 7,
  columns_bills_sm                               : 7,

  netTimeout                                    : 60000,
  netTimeout_large                              : 99000,

  bills_exclude_flags_enabled                   : true,

  allow_hp_to_be_edited                         : true, //honeypot//honeymoon
};
